import tr from "./tr";
import en from "./en";
import ar from "./ar";

import enValid from "vee-validate/dist/locale/en.json";
import trValid from "vee-validate/dist/locale/tr.json";
import arValid from "vee-validate/dist/locale/ar.json";

const trExtended = Object.assign(tr, { validation: Object.assign(tr.validation || {}, trValid.messages) });
const enExtended = Object.assign(en, { validation: Object.assign(en.validation || {}, enValid.messages) });
const arExtended = Object.assign(ar, { validation: Object.assign(ar.validation || {}, arValid.messages) });

export default {
  tr: trExtended,
  en: enExtended,
  ar: arExtended
};
